import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import { openExternalUrl, type ModerationToolLink } from '@/lib/moderationToolLinks';

export function ExternalToolLinkRow({
  link,
  className,
}: {
  link: ModerationToolLink;
  className?: string;
}) {
  const Icon = link.icon;

  return (
    <button
      type="button"
      onClick={() => openExternalUrl(link.url)}
      className={cn(
        'flex w-full items-center gap-4 rounded-lg px-5 py-3 text-sm text-sidebar-foreground',
        'hover:bg-sidebar-accent',
        className,
      )}
    >
      <Icon className="size-5 shrink-0" />
      <span className="min-w-0 flex-1 truncate text-left">{link.label}</span>
      <ExternalLink className="size-4 shrink-0 opacity-70" aria-hidden />
      <span className="sr-only">Opens in new tab</span>
    </button>
  );
}
